<template>
  <div class="activity">



    <div :class="[isMobile ? 'news-title-mobile' : 'news-title']">
      <label :class="[isMobile ? 'news-msg-mobile' : 'news-msg']">會務動態</label>
    </div>

    <div :class="[isMobile ? 'activity-list-mobile' : 'activity-list']">

      <div v-for="(item, index) of activityList" :key="index" class="activity-item">

        <img class="activity-img" @click=choose(item) :src="item.cover">

        <span class="title" style="" @click=choose(item)>{{ item.title }}</span>

        <label style="color:#A05200;font-size: 16px;">{{ item.guide }}</label>
      </div>

    </div>


    <el-pagination :class="[isMobile ? 'news-bottom-page-mobile' : 'news-bottom-page']" background
      layout="prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange" :small="isMobile"
      :current-page="queryInfo.page" :page-size="queryInfo.pagesize" :page-sizes="[1, 2, 5, 10]" :total="totalNum">
    </el-pagination>

  </div>
</template>


<script>

export default {
  name: 'News',
  data() {
    return {
      whichYear: "全部",
      activityList: [],
      totalNum: 0,
      queryInfo: {
        query: "",
        // 当前页数
        page: 1,
        // 显示一页多少条数据
        pagesize: 9,
      },
      isMobile: false
    }
  },
  created() {
    this.isMobile = window.isMobile
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var that = this;

      this.$axios.get("article/lists", { params: { cateId: "11", page: this.queryInfo.page, limit: this.queryInfo.pagesize } }).then(function (response) {
        // console.log('lists ' + JSON.stringify(response.data.data));
        that.activityList = response.data.data
        that.totalNum = response.data.count

        window.scrollTo({
          top: 0,
        });

      }, function (err) {
        console.log('errerrerrerrerr ' + err);
      });
    },
    handleCommand(command) {
      this.whichYear = command
    },
    choose(item) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      //// console.log('click on item ' + item);
      //  this.$message('click on item ' + index);
      this.$router.push({ name: 'detail', params: { type: "activity", data: item, } });
    },
    //每页的数据条数的需求，重新调用方法获取新的数据
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val;
      this.fetchData();
    },
    //识别到页数的变化，自动获取新的数据
    handleCurrentChange(val) {
      
      // console.log(`当前页: ${val}`);
      this.queryInfo.page = val;
      this.fetchData();
    }
  },
}
</script>


<style lang="scss" rel="stylesheet/scss">
.activity {
  justify-content: center;
  width: 100%;
  flex-direction: column;
  display: flex;
  box-sizing: border-box;
  align-items: center;


  .news-title {
    margin-top: 30px;
    width: 1040px;
    display: flex;
    justify-content: space-between;

    .news-msg {
      font-size: 28px;
      color: #301E03
    }
  }

  .news-title-mobile {
    box-sizing: border-box;
    padding-left: 20px;
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .news-msg-mobile {
      font-size: 22px;
      color: #301E03
    }
  }



  .activity-list {
    width: 1040px;
    margin-top: 30px;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    flex-wrap: wrap;

    .title {
      font-size: 18px;
      color: #301E03;
        margin-top: 20px;
        cursor: pointer;
        overflow: hidden;
        height: 45px;
        line-height: 22px;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        margin-bottom: 20px;
    }

    .activity-item {
      padding: 14px;
      margin-right: 14px;
      border-radius: 12px;
      background-color: white;
      height: 338px;
      margin-bottom: 14px;
      width: calc((100% - 56px) / 3);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;


      .activity-img {
        width: 100%;
        height: 200px;
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }




  .activity-list-mobile {
    box-sizing: border-box;
    padding: 0px 20px;
    width: 100%;
    margin-top: 20px;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;

    .title {
      font-size: 18px;
      color: #301E03;
        margin-top: 20px;
        cursor: pointer;
        overflow: hidden;
        height: 45px;
        line-height: 22px;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        margin-bottom: 20px;
    }

    .activity-item {
      padding: 14px;
      border-radius: 12px;
      background-color: white;
      margin-bottom: 14px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;


      .activity-img {
        max-width: 100%;
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }

  .news-bottom-page {
    margin-top: 80px;
    margin-bottom: 88px;
  }

  .news-bottom-page-mobile {
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #D9C8AD;
    color: #fff;
  }

}
</style>
